import { useLocalStorageState } from 'ahooks'

const HAS_SIGNED_IN_BEFORE_KEY = 'tad_ai_has_signed_in_before'

export function useJoinCreditsHintVisibility(isSignIn: boolean) {
  const [hasSignedInBefore, setHasSignedInBefore] = useLocalStorageState(
    HAS_SIGNED_IN_BEFORE_KEY,
    {
      defaultValue: false,
    },
  )

  useEffect(() => {
    if (!isSignIn) return
    setHasSignedInBefore(true)
  }, [isSignIn, setHasSignedInBefore])

  return {
    hasSignedInBefore,
  }
}
